<template>
  <div :style="'overflow-x: hidden;background:'+bgColor">	
      <div style="width: 1190px;    margin: 0 auto;">
		  <!-- ../assets/images/naihuocailiao.jpg -->
      		<div style="width: 1920px;   height: 456px;overflow: hidden; margin-left: -357px;" class="banner-c"><img :src="bannerImage"></div>
      </div>
	  <div class="crumbs-all">
		  <div class="crumbs-c" >
			  <div v-if="currentLanguage=='zh'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">首页</div><div style="cursor: pointer" @click="goCurrentHome">> {{company.companyName}}</div> </div>
			  <div v-if="currentLanguage=='en'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">Home Page </div> <div style="cursor: pointer" @click="goCurrentHome">> {{company.enCompanyName}}</div></div>
			  <div v-if="currentLanguage=='ko'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">첫 페이지</div><div style="cursor: pointer" @click="goCurrentHome">>  {{company.companyName}}</div> </div>
			  <div v-if="currentLanguage=='ja'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">最初のページ</div> <div style="cursor: pointer" @click="goCurrentHome">> {{company.jaCompanyName}}</div></div>
		  </div>
	  </div>
	  <div class="product-c content-bd commom-product-c" style="width: 1232px;">
		<div class="f-l" :style="'background:'+leftBlockColor">
			<div class="l-content" >
				<!-- <template v-if="indexConfig.nhCategoryPositionObj">
					<img :src="nhCategoryBgUrl" class="bg-img" :style="'width:'+indexConfig.nhCategoryPositionObj.width+'px;height:'+indexConfig.nhCategoryPositionObj.height+'px;left:'+indexConfig.nhCategoryPositionObj.left+'px;bottom:'+indexConfig.nhCategoryPositionObj.bottom+''">
				</template> -->
				<div class="head-c">
					<div style="margin: 10px 0;padding-bottom:10px;font-size: 18px;color: #0070B7;">
						
						<!-- <template v-if="currentLanguage=='zh'">产品中心</template>
						<template v-if="currentLanguage=='en'">product center</template>
						<template v-if="currentLanguage=='ko'">제품 센터</template>
						<template v-if="currentLanguage=='ja'">製品センター</template>	 -->
					</div>		
				</div>
				<ul>
					<!-- <li v-for="(category,index) in categoryList"  :key="index" :class="{on:index==currentCategory}" @mouseenter="currentCategory=index" @mouseleave="currentCategory=null">
						<template>{{category.label}}</template>
						
						<span class="arrow-ico"></span>
						<div class="second-category" v-show="index==currentCategory"  @mouseenter="currentCategory=index" @mouseleave="currentCategory=null" >
							<div v-for="(secondCategory,index) in category.children" style="line-height: 38px;margin-left: 10px;">
								<div class="second-c" :class="{on:currentSecondCategory==index,title:secondCategory.key==null}"  @mouseenter="currentSecondCategory=index" @mouseleave="currentSecondCategory=null" >
									<span class="second-ico" style="margin-right: 10px;"></span>
									<template>{{secondCategory.label}}</template>
									<div class="second-c third-c" style="width:100%;height:48px;cursor: pointer;" v-for="(thirdCategory,index2) in secondCategory.children" @click.stop="getProductByCategory(thirdCategory)">
										•{{thirdCategory.label}}
									</div>
							    </div>
							</div>
						</div>
					</li> -->
					 <el-tree :data="categoryList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
				</ul>
				<!-- <ul>
					<li v-for="(category,index) in categoryList"  :key="index" :class="{on:index==currentCategory}" @mouseenter="currentCategory=index" @mouseleave="currentCategory=null">
						<template v-if="currentLanguage=='zh'">{{category.zh}}</template>
						<div v-if="currentLanguage=='en'" style="font-size: 14px;">{{category.en}}</div>
						<template v-if="currentLanguage=='ko'">{{category.ko}}</template>
						<template v-if="currentLanguage=='ja'">{{category.ja}}</template>
						<span class="arrow-ico"></span>
						<div class="second-category" v-show="index==currentCategory"  @mouseenter="currentCategory=index" @mouseleave="currentCategory=null" >
							<div v-for="(secondCategory,index) in category.child" style="line-height: 38px;height: 48px;margin-left: 10px;">
								<div class="second-c" :class="{on:currentSecondCategory==index,title:secondCategory.key==null}"  @mouseenter="currentSecondCategory=index" @mouseleave="currentSecondCategory=null" @click="getProductByCategory(secondCategory)">
									<span class="second-ico" style="margin-right: 10px;"></span>
									<template v-if="currentLanguage=='zh'">{{secondCategory.zh}}</template>
									<template v-if="currentLanguage=='en'">{{secondCategory.en}}</template>
									<template v-if="currentLanguage=='ko'">{{secondCategory.ko}}</template>
									<template v-if="currentLanguage=='ja'">{{secondCategory.ja}}</template>
							    </div>
							</div>
						</div>
					</li>
				</ul> -->
			</div>
		</div>
		
		<div class="product-right-c f-r" :style="'background:'+rightBlockColor">
			<div style="display: flex;flex-direction: row;justify-content: space-between;">
				<div class="product-head-c">
					<div class="title" v-if="!isShowProduct">
						<template>{{detailCompanyInfo.title}}</template>			
					</div>
					<div class="title" v-if="isShowProduct">
						<template>{{detailContent.productName}}</template>
						<!-- <span style="font-size: 16px;color: #999;font-weight: 100;margin-left: 10px;">Detail content</span> -->
					</div>
					<!-- <div class="line-c"><span></span></div>				 -->
				</div>
				<div v-if="!isShowProduct" class="book-c">
				<div class="book-c-wrapper">
					<div v-for="(item,index) in zhuanLiList" :key="index"  @click="getBookDetail(item)">
						<img :src="item.icoList[0].url" :style="getStyle(item)">
					</div>					
				</div>
			</div>
			</div>
			
			<div v-if="!isShowProduct" style="line-height: 30px;" v-html="detailCompanyInfo.content">
				    
			</div>
			
			<div style="text-align: center;min-height: 700px;" v-show="isShowProduct">
				
			    <!-- <div class="product-canvas" :class="getColorClass(currentSelectedSecondCategory)" style="position: relative;margin-left: 47px;">
			      <canvas id="areaCanvas" style="margin-left: -100px;" v-show="isShowCanvas"></canvas>
			      <div  id="textContent" class="tip-content">
			    	  <div class="tip" v-for="(num,index) in selectedContent" v-show="index==infoIndex">
					   <div class="title">{{getCanvasLanguageTitle(num)}}</div>
					
					  {{getCanvasLanguageContent(num)}}
					  </div>
			      </div>
			    </div> -->
				<div v-html="detailContent.detail"></div>
				<!-- <img :src="icoBigImage" v-if="showIcoImage" style="width:100%"> -->
			</div>
		</div>
		
		<div class="clearfix"></div>
	  </div>
	  <p-bottom :lang="lang"></p-bottom>
  </div>
</template>

<script>
var inside = require('point-in-polygon');
import treeItem from "../components/treeMenu.vue"
export default {
  name: 'RefractoryProducts',
  props:{
  	lang:{}
  }, 
  components:{
	  treeItem
  },
  data() {
    return {
      categoryList:[
		  {zh:'炼铁系统',en:'Ironmaking system',ko:'제철 시스템',ja:'製鉄システム',child:[{zh:"铁水包",en:'Molten iron ladle',ko:'철수포',ja:'ブリキの包み',key:1,imageUrl:require('../assets/images/model/1-1.jpg')},{zh:"鱼雷罐",en:'Torpedo tank',ko:'어뢰통',ja:'魚雷の壺',key:2,imageUrl:require('../assets/images/model/1-2.jpg')}]},
		  {zh:'炼钢系统',en:'Steelmaking system',ko:'제강 시스템',ja:'製鋼システム',
				child:[{zh:"铁水预处理区域",en:'converter',ko:'회전로',ja:'回転炉',key:3,imageUrl:require('../assets/images/model/null-bd.png')},{zh:"转炉炼钢",en:'converter',ko:'회전로',ja:'回転炉',key:null},{zh:"• 转炉",en:'HRfurnace',ko:'작은 요정',ja:'ポケモン',key:6,imageUrl:require('../assets/images/model/2-4.jpg')},{zh:"二次精炼系统",en:'Permeable brick',ko:'공기벽돌',ja:'通気れんが',key:null},{zh:"• RH炉",en:'Permeable brick',ko:'공기벽돌',ja:'通気れんが',key:7,imageUrl:require('../assets/images/model/2-5.jpg')},{zh:"• LF炉",en:'Permeable brick',ko:'공기벽돌',ja:'通気れんが',key:8,imageUrl:require('../assets/images/model/2-6.jpg')}]},
		  {zh:'连铸系统',en:'Continuous casting system',ko:'주조 시스템',ja:'ダイカストシステム',
			    child:[{zh:"钢包",en:'converter',ko:'회전로',ja:'回転炉',key:null},{zh:"• 转炉钢包",en:'Ladle',ko:'강낭',ja:'スチール？バッグ',key:9,imageUrl:require('../assets/images/model/3-1.jpg')},{zh:"• 电炉钢包",en:'Ladle',ko:'강낭',ja:'スチール？バッグ',key:10,imageUrl:require('../assets/images/model/3-2.jpg')},{zh:"钢包-中间包",en:'Sliding system',ko:'미끄럼 시스템',ja:'スライドシステム',key:11,imageUrl:require('../assets/images/model/3-3.jpg')},{zh:"中间包",en:'Tundish',ko:'중간 가방',ja:'中ほどのカバン',key:12,imageUrl:require('../assets/images/model/3-4.jpg')},{zh:"中间包-连铸",en:'Tundish',ko:'중간 가방',ja:'中ほどのカバン',key:13}]},
	  ],
	  data: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
		defaultProps: {
          tree: 'tree',
          label: 'label'
        },
	  currentCategory:null,
	  currentSecondCategory:null,
	  currentSelectedSecondCategory:1,
	  bgColor:'#fff',
	  currentLanguage:'',
	  isShowProduct:false,
	  isShowCanvas:true,
	  currentSelectedSecondName:'',
	  moltenIronLadleArr:[
	  			{
					zh:{name:'包口',content:"铝碳化硅浇注料、铝碳化硅喷涂料"},
				    en:{name:'Bao Kou',content:"ASC castable with excellent thermal shock resistance and erosion resistance"},
					ko:{name:'꾸러미',content:"내열 지진 성능과 브러시 기능이 우수한 AST 소재를 설정합니다."},
					ja:{name:'包装口',content:"耐热振动性能と耐冲撃性に优れたASC素材の注入剤を配置します"},
	  			    point:[[185,165],[194,158],[206,151],[224,146],[244,141],[271,137],[296,135],[325,133],[336,139],[362,164],[396,203],[429,241],[408,243],[357,251],[301,264],[239,282],[203,297],[190,305],[184,282],[182,246],[182,199],[183,179],]
	  			},
	  			{
					zh:{name:'渣线区域',content:"铝碳化硅碳砖"},
					en:{name:'Tie line area',content:"ASC brick with good slag resistance and oxidation resistance"},
					ko:{name:'단선 구역',content:"부스러기 저항성 좋은 항산화 성능 우수한 AST 벽돌"},
					ja:{name:'結束区域',content:"スラグ耐性の高い抗酸化性能に優れたASCレンガを配置します"},
					point:[[190,305],[199,296],[217,288],[243,279],[277,270],[310,260],[345,253],[375,247],[407,243],[429,242],[459,243],[488,248],[523,253],[552,261],[578,273],[594,284],[598,299],[598,310],[579,316],[574,328],[559,337],[548,385],[507,373],[472,362],[423,352],[375,350],[328,352],[282,363],[248,375],[245,340],[226,331],[207,322],]
	  			},
	  			{
					zh:{name:'铁线区域',content:"铝碳化硅碳砖"},
					en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
					ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
					ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
					point:[[249,373],[286,361],[340,351],[394,352],[440,356],[484,367],[546,388],[528,558],[503,545],[462,529],[415,519],[373,517],[333,521],[309,529],[277,542],[258,548]],
	  			},
	  			{
					zh:{name:'包底非冲击区',content:"铝碳化硅碳砖"},
					en:{name:'Non impact area',content:"ASC brick with high strength and excellent overall performance"},
					ko:{name:'비충격 구역',content:"강도가 높고 전체 성능이 우수한 AST 벽돌 설정"},
					ja:{name:'非衝撃ゾーン',content:"配置強度が高く、全体性能が優れたASCレンガです"},
					point:[[260,550],[293,534],[341,522],[387,517],[439,524],[484,537],[528,559],[519,644],[449,613],[481,585],[402,547],[393,544],[299,593],[300,602],[323,616],[265,644]]
	  			},
	  			{
					zh:{name:'包底冲击区',content:"铝碳化硅碳砖"},
					en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
					ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
					ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
					point:[[301,593],[388,547],[400,545],[476,581],[475,594],[447,612],[387,585],[322,617],[298,599],],
	  			},
	  			{
					zh:{name:'永久层',content:"蜡石砖"},
					en:{name:'Permanent layer',content:"Equipped with burnt wax stone brick"},
					ko:{name:'영구층',content:"왁스 타일"},
					ja:{name:'恒久層',content:"ワックスがけの配置"},
					point:[[562,338],[568,338],[555,409],[551,449],[532,654],[529,661],[389,599],[262,659],[255,660],[234,345],[240,342],[259,651],[262,653],[386,593],[523,651],[525,644],[549,412]],
	  			},
	  			{
					zh:{name:'保温层',content:"镁硅质保温板"},
					en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
					ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
					ja:{name:'保温層',content:"高強度軽量保温板の配置"},
					point:[[569,338],[572,338],[561,404],[539,649],[534,666],[529,667],[387,605],[261,663],[255,665],[249,661],[237,449],[227,347],[233,346],[253,650],[255,660],[259,661],[387,599],[525,660],[531,660],[555,409]],
	  			}
	  		],
	  zhuanLuGangBaoArr:[
	  			{
	  					zh:{name:'包口',content:"铝镁质浇注料或高铝预制块"},
	  				    en:{name:'Bao Kou',content:"ASC castable with excellent thermal shock resistance and erosion resistance"},
	  					ko:{name:'꾸러미',content:"내열 지진 성능과 브러시 기능이 우수한 AST 소재를 설정합니다."},
	  					ja:{name:'包装口',content:"耐热振动性能と耐冲撃性に优れたASC素材の注入剤を配置します"},
	  			    point:[[297,251],[279,247],[258,241],[237,232],[220,221],[207,210],[200,195],[200,181],[206,166],[218,154],[231,147],[248,139],[267,131],[293,125],[318,121],[345,117],[368,116],[391,115],[413,116],[435,118],[457,120],[480,123],[501,128],[523,136],[545,147],[564,161],[573,175],[573,189],[567,201],[561,209],[543,206],[549,197],[553,184],[551,173],[541,159],[521,147],[497,137],[469,130],[433,125],[404,123],[374,122],[348,124],[319,128],[293,133],[269,140],[249,149],[239,157],[227,168],[223,184],[226,197],[241,211],[265,225],[287,233],[308,237],[298,247]]
	  			},
	  			{
	  					zh:{name:'渣线',content:"低碳镁碳砖或普通镁碳砖"},
	  					en:{name:'Tie line area',content:"ASC brick with good slag resistance and oxidation resistance"},
	  					ko:{name:'단선 구역',content:"부스러기 저항성 좋은 항산화 성능 우수한 AST 벽돌"},
	  					ja:{name:'結束区域',content:"スラグ耐性の高い抗酸化性能に優れたASCレンガを配置します"},
	  					point:[[310,238],[296,235],[281,229],[263,223],[245,214],[233,206],[225,194],[223,180],[227,168],[235,159],[253,148],[272,139],[291,134],[313,129],[336,125],[361,123],[389,121],[419,123],[448,127],[474,131],[495,137],[513,143],[535,155],[549,169],[553,181],[552,189],[548,199],[541,207],[551,208],[537,348],[529,347],[534,289],[521,277],[509,270],[495,263],[477,257],[459,251],[439,248],[418,246],[397,245],[378,245],[359,245],[343,248],[319,251],[311,253],[316,375],[311,382],[305,241]]
	  			},
	  			{
	  					zh:{name:'包壁',content:"刚玉尖晶石质预制块或浇注料"},
	  					en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
	  					ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
	  					ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
	  					point:[[310,254],[322,251],[335,248],[355,247],[377,245],[404,246],[422,246],[442,249],[459,253],[477,257],[496,264],[511,273],[525,285],[535,293],[530,347],[539,349],[524,511],[521,519],[515,519],[516,509],[520,461],[512,449],[496,436],[482,427],[466,421],[451,417],[429,413],[407,409],[389,409],[368,411],[349,413],[334,416],[317,420],[324,557],[320,556],[320,547],[313,383],[318,377]],
	  			},
	  			{
	  					zh:{name:'永久层',content:"高铝质浇注料"},
	  					en:{name:'Non impact area',content:"ASC brick with high strength and excellent overall performance"},
	  					ko:{name:'비충격 구역',content:"강도가 높고 전체 성능이 우수한 AST 벽돌 설정"},
	  					ja:{name:'非衝撃ゾーン',content:"配置強度が高く、全体性能が優れたASCレンガです"},
	  					point:[[550,209],[556,209],[529,510],[526,521],[520,525],[513,526],[491,521],[491,502],[475,472],[437,489],[437,507],[388,496],[365,518],[365,502],[350,497],[326,520],[339,529],[341,546],[327,561],[322,563],[319,561],[318,557],[303,243],[306,241],[320,555],[323,558],[327,555],[339,541],[340,529],[326,521],[351,497],[365,501],[367,513],[388,491],[435,502],[436,489],[475,471],[492,501],[493,515],[510,519],[517,520],[522,517],[524,511]]
	  			},
	  			{
	  					zh:{name:'保温层',content:"高强度轻质绝热板或轻质预制块"},
	  					en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
	  					ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
	  					ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
	  					point:[[555,209],[561,211],[535,518],[533,526],[529,532],[521,535],[515,535],[493,528],[491,503],[475,472],[437,489],[436,515],[389,502],[365,527],[363,503],[351,497],[326,521],[340,529],[340,553],[325,571],[320,573],[317,572],[314,568],[299,246],[303,243],[318,559],[321,563],[326,562],[339,549],[339,530],[325,521],[349,497],[364,503],[367,517],[387,496],[436,507],[436,489],[475,471],[492,503],[494,521],[513,526],[522,525],[529,517]],
	  			},
	  			{
	  					zh:{name:'包底冲击区预制块',content:"刚玉尖晶石质"},
	  					en:{name:'Permanent layer',content:"Equipped with burnt wax stone brick"},
	  					ko:{name:'영구층',content:"왁스 타일"},
	  					ja:{name:'恒久層',content:"ワックスがけの配置"},
	  					point:[[321,451],[335,436],[351,425],[397,437],[394,445],[385,458],[371,469],[355,481],[320,472]],
	  			},
	  			{
	  					zh:{name:'水口系统',content:"暂无说明"},
	  					en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
	  					ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
	  					ja:{name:'保温層',content:"高強度軽量保温板の配置"},
	  					point:[[435,514],[438,489],[474,473],[492,503],[492,527],[483,526],[481,540],[487,543],[493,547],[489,547],[480,545],[475,545],[473,554],[469,567],[465,566],[461,567],[457,549],[455,539],[443,535],[439,533],[439,530],[445,532],[447,531],[447,517]],
	  			},
				{
						zh:{name:'透气砖',content:"铬刚玉尖晶石质"},
						en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
						ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
						ja:{name:'保温層',content:"高強度軽量保温板の配置"},
						point:[[348,545],[348,520],[357,509],[359,512],[359,516],[366,538],[363,542],[360,545],[355,547],[350,546]],
				},
				{
						zh:{name:'透气座砖',content:"刚玉尖晶石质"},
						en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
						ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
						ja:{name:'保温層',content:"高強度軽量保温板の配置"},
						point:[[348,545],[342,552],[340,528],[326,520],[351,497],[364,502],[366,525],[364,527],[357,509],[347,520]],
				},
				{
						zh:{name:'包底非冲击区',content:"刚玉尖晶石质"},
						en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
						ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
						ja:{name:'保温層',content:"高強度軽量保温板の配置"},
						point:[[339,542],[324,557],[321,471],[350,479],[355,479],[361,477],[377,465],[390,451],[398,438],[353,424],[349,427],[333,439],[326,445],[321,451],[319,452],[319,424],[324,421],[333,418],[344,414],[359,412],[377,411],[396,410],[414,411],[434,414],[451,417],[470,422],[483,427],[495,435],[506,445],[515,453],[521,461],[516,520],[513,521],[508,520],[497,517],[492,515],[492,503],[476,472],[438,487],[435,503],[387,491],[365,514],[365,501],[350,496],[326,521],[339,529]],
				}
	  		],		
		yuLeiGuanArr:[
					{
							zh:{name:'永久层',content:"蜡石砖"},
						    en:{name:'Bao Kou',content:"ASC castable with excellent thermal shock resistance and erosion resistance"},
							ko:{name:'꾸러미',content:"내열 지진 성능과 브러시 기능이 우수한 AST 소재를 설정합니다."},
							ja:{name:'包装口',content:"耐热振动性能と耐冲撃性に优れたASC素材の注入剤を配置します"},
					        point:[[381,201],[325,207],[171,263],[154,272],[146,281],[145,326],[149,348],[155,360],[174,370],[202,369],[247,374],[331,375],[506,343],[512,345],[519,347],[530,345],[539,337],[549,312],[552,291],[551,263],[547,246],[537,216],[527,197],[513,184],[508,184],[485,186],[488,193],[509,191],[517,197],[529,213],[539,235],[546,261],[547,287],[545,309],[537,329],[525,339],[515,341],[507,336],[332,368],[179,362],[166,360],[159,351],[153,321],[151,291],[157,281],[168,273],[318,216],[381,209]]
					},
					{
							zh:{name:'渣线',content:"铝碳化硅碳砖"},
							en:{name:'Tie line area',content:"ASC brick with good slag resistance and oxidation resistance"},
							ko:{name:'단선 구역',content:"부스러기 저항성 좋은 항산화 성능 우수한 AST 벽돌"},
							ja:{name:'結束区域',content:"スラグ耐性の高い抗酸化性能に優れたASCレンガを配置します"},
							point:[[169,311],[214,296],[319,261],[507,240],[533,237],[521,215],[511,205],[477,209],[477,221],[391,232],[387,229],[385,221],[318,230],[177,284],[168,291]]
					},
					{
							zh:{name:'罐口',content:"刚玉莫来石浇注料 "},
							en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
							ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
							ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
							point:[[380,201],[378,197],[379,186],[386,181],[397,177],[412,175],[427,175],[447,175],[466,177],[477,180],[483,183],[487,195],[478,195],[477,220],[390,231],[387,227],[388,221],[388,208]],
					},
					{
							zh:{name:'冲击区',content:"铝碳化硅碳砖"},
							en:{name:'Non impact area',content:"ASC brick with high strength and excellent overall performance"},
							ko:{name:'비충격 구역',content:"강도가 높고 전체 성능이 우수한 AST 벽돌 설정"},
							ja:{name:'非衝撃ゾーン',content:"配置強度が高く、全体性能が優れたASCレンガです"},
							point:[[351,278],[431,267],[438,302],[363,316]]
					},
					{
							zh:{name:'安全层',content:"高铝涂抹料"},
							en:{name:'Non impact area',content:"ASC brick with high strength and excellent overall performance"},
							ko:{name:'비충격 구역',content:"강도가 높고 전체 성능이 우수한 AST 벽돌 설정"},
							ja:{name:'非衝撃ゾーン',content:"配置強度が高く、全体性能が優れたASCレンガです"},
							point:[[167,281],[182,275],[314,225],[388,214],[389,232],[478,220],[478,203],[508,198],[513,200],[517,204],[525,213],[531,223],[539,242],[543,268],[543,289],[540,308],[537,319],[531,327],[521,333],[514,333],[508,331],[329,364],[174,354],[166,351],[164,347],[159,294],[161,287],[164,287],[164,290],[168,342],[169,346],[172,348],[178,350],[324,360],[505,328],[512,329],[517,329],[525,326],[534,319],[538,307],[541,287],[541,268],[537,242],[525,219],[514,204],[507,201],[479,206],[479,221],[389,233],[386,219],[367,221],[340,225],[320,227],[307,232],[170,284]]
					},
					{
							zh:{name:'锥部',content:"铝碳化硅碳砖"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[148,349],[157,363],[175,371],[335,377],[361,370],[337,335],[323,297],[318,257],[318,206],[169,257],[147,270],[139,282],[137,297],[139,324],[143,341]],
					},
					
				],
		zhuanLuArr:[
					{
							zh:{name:'炉帽',content:"镁碳砖"},
							en:{name:'Tie line',content:"Magnesia carbon brick with excellent oxidation resistance and erosion resistance"},
							ko:{name:'실을 묶다',content:"항산화 성능과 침식 성능 우수한 마그네슘 벽돌"},
							ja:{name:'糸をくくる',content:"抗酸化性能と抗侵食性能に優れたマグネシウムれんがを配置します"},
						point:[[105,351],[84.,320],[83.,313],[86.,303],[100,281],[131,242],[171,206],[217,173],[265,145],[299,129],[339,114],[374,107],[399,103],[416,103],[425,103],[443,130],[439,140],[551,199],[508,234],[467,229],[432,231],[409,241],[383,251],[347,265],[317,285],[281,307],[227,347],[195,381],[172,409],[167,434],[163,454],[111,477],[112,351],]
					},
					{
							zh:{name:'出钢口',content:"镁碳砖"},
							en:{name:'Weld pool',content:"ASC brick with good slag resistance and oxidation resistance"},
							ko:{name:'용못',content:"부스러기 저항성 좋은 항산화 성능 우수한 AST 벽돌"},
							ja:{name:'溶融池',content:"スラグ耐性の高い抗酸化性能に優れたASCレンガを配置します"},
							point:[[67.,495],[71.,491],[77.,499],[121,477],[122,486],[125,491],[172,463],[191,495],[145,521],[152,532],[112,555],[116,565],[110,567]]
					},
					{
							zh:{name:'永久层',content:"配置抗氧化性能和抗侵蚀性能优良的镁碳砖"},
							en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
							ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
							ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
							point:[[145,536],[151,533],[277,711],[294,728],[327,753],[363,763],[393,763],[427,757],[476,743],[533,719],[570,697],[607,663],[641,627],[665,593],[685,560],[695,530],[695,496],[687,459],[665,416],[553,209],[545,203],[409,135],[411,131],[559,205],[567,214],[690,445],[707,529],[708,543],[700,561],[681,593],[641,643],[597,687],[525,735],[486,753],[413,775],[375,781],[351,778],[275,720],[148,544]],
					},
					{
							zh:{name:'后大面',content:"镁碳砖"},
							en:{name:'Non impact area',content:"ASC brick with high strength and excellent overall performance"},
							ko:{name:'비충격 구역',content:"강도가 높고 전체 성능이 우수한 AST 벽돌 설정"},
							ja:{name:'非衝撃ゾーン',content:"配置強度が高く、全体性能が優れたASCレンガです"},
							point:[[146,521],[191,493],[166,456],[166,442],[170,417],[184,396],[197,382],[200,379],[332,579],[326,589],[318,604],[313,621],[309,633],[309,652],[311,668],[268,698]]
					},
					{
							zh:{name:'前大面',content:"镁碳砖"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[413,241],[451,228],[462,228],[481,230],[506,235],[549,209],[554,210],[670,429],[633,456],[617,450],[600,443],[580,443],[555,445],[529,451]],
					},
					{
							zh:{name:'耳轴',content:"镁碳砖"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[198,379],[223,352],[254,329],[289,301],[316,285],[354,263],[385,248],[413,242],[533,448],[513,455],[496,459],[464,475],[434,490],[414,506],[384,527],[361,547],[345,565],[334,583]],
					},
					{
							zh:{name:'风口砖',content:"镁碳砖"},
							en:{name:'Permanent layer',content:"Equipped with burnt wax stone brick"},
							ko:{name:'영구층',content:"왁스 타일"},
							ja:{name:'恒久層',content:"ワックスがけの配置"},
							point:[[478,694],[492,737],[510,728],[492,689]],
					},
					{
							zh:{name:'熔池',content:"镁碳砖"},
							en:{name:'Permanent layer',content:"Equipped with burnt wax stone brick"},
							ko:{name:'영구층',content:"왁스 타일"},
							ja:{name:'恒久層',content:"ワックスがけの配置"},
							point:[[312,670],[306,649],[309,629],[315,607],[334,576],[355,552],[379,530],[402,511],[431,493],[457,478],[488,463],[516,454],[537,448],[568,444],[597,444],[619,451],[634,456],[672,431],[680,447],[685,459],[691,476],[692,496],[695,518],[690,542],[685,561],[681,572],[633,556],[623,547],[600,543],[566,543],[536,551],[517,558],[491,572],[460,591],[437,612],[416,636],[397,667],[392,691],[398,714],[390,764],[362,763],[339,757],[322,749],[306,738],[284,721],[270,696]],
					},
					{
							zh:{name:'炉底',content:"镁碳砖"},
							en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
							ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
							ja:{name:'保温層',content:"高強度軽量保温板の配置"},
							point:[[389,765],[398,715],[396,705],[394,683],[400,661],[412,637],[434,615],[456,596],[487,576],[510,563],[529,554],[551,549],[576,543],[597,543],[618,545],[638,556],[680,567],[676,578],[659,600],[632,637],[575,692],[552,708],[523,725],[511,729],[491,687],[477,696],[491,737],[481,742],[454,750],[426,758],[403,761]],
					}
				],
		RHLuArr:[
			        {
			        		zh:{name:'氧枪孔',content:"暂无说明"},
			        		en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
			        		ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
			        		ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
			        		point:[[399,160],[399,118],[398,116],[399,112],[405,112],[418,112],[424,114],[424,118],[422,119],[419,186]],
			        },
			        {
			        		zh:{name:'窥视孔',content:"暂无说明"},
			        		en:{name:'Non impact area',content:"ASC brick with high strength and excellent overall performance"},
			        		ko:{name:'비충격 구역',content:"강도가 높고 전체 성능이 우수한 AST 벽돌 설정"},
			        		ja:{name:'非衝撃ゾーン',content:"配置強度が高く、全体性能が優れたASCレンガです"},
			        		point:[[427,196],[428,145],[426,145],[426,140],[429,139],[439,139],[448,141],[451,142],[451,146],[449,146],[450,225]]
			        },
					{
							zh:{name:'热弯管',content:"不烧镁尖晶石砖、刚玉尖晶石质浇注料、刚玉尖晶石质预制块"},
							en:{name:'Bao Kou',content:"ASC castable with excellent thermal shock resistance and erosion resistance"},
							ko:{name:'꾸러미',content:"내열 지진 성능과 브러시 기능이 우수한 AST 소재를 설정합니다."},
							ja:{name:'包装口',content:"耐热振动性能と耐冲撃性に优れたASC素材の注入剤を配置します"},
						point:[[208,285],[201,282],[194,280],[187,275],[185,270],[181,204],[254,116],[264,112],[270,112],[392,121],[398,124],[399,119],[398,116],[399,113],[404,112],[418,112],[423,114],[424,118],[423,119],[421,150],[428,159],[428,145],[426,144],[427,141],[429,139],[438,139],[448,140],[451,142],[452,145],[450,146],[451,186],[479,222],[479,226],[479,285],[477,290],[478,295],[472,301],[469,305],[451,308],[437,309],[416,310],[396,310],[372,311],[362,309],[349,304],[343,300],[338,293],[338,272],[327,255],[316,253],[316,269],[312,274],[304,278],[295,282],[288,283],[280,284],[267,286],[254,286],[236,286],[218,286]]
					},
					{
							zh:{name:'保温层',content:"暂无说明"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[369,320],[370,320],[370,325],[370,332],[368,341],[356,389],[356,393],[357,696],[356,695],[355,692],[355,623],[353,392],[367,332],[368,325]],
					},
					
					{
							zh:{name:'永久层',content:"轻质高铝砖、硅钙板"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[249,191],[245,177],[242,160],[243,143],[247,129],[255,119],[264,113],[387,124],[401,140],[401,118],[406,117],[415,119],[418,119],[418,161],[429,175],[430,145],[437,145],[445,145],[447,198],[470,227],[468,303],[473,305],[473,322],[495,380],[495,398],[506,384],[508,373],[517,374],[523,373],[532,373],[537,376],[547,380],[546,403],[492,469],[486,678],[480,682],[487,472],[488,469],[544,402],[545,381],[536,378],[532,375],[524,376],[516,377],[509,377],[509,385],[486,414],[488,382],[469,328],[468,306],[466,305],[468,228],[446,200],[444,148],[432,148],[431,180],[416,163],[416,123],[406,120],[403,121],[402,145],[387,126],[265,117],[256,121],[249,131],[246,141],[245,156],[245,168],[249,181],[252,191],[327,200],[374,260],[373,309],[372,313],[372,332],[359,389],[359,393],[360,697],[356,696],[356,393],[356,389],[369,331],[370,310],[371,308],[372,261],[326,202],[252,193]],
					},
					{
							zh:{name:'合金溜槽',content:"暂无说明"},
							en:{name:'Permanent layer',content:"Equipped with burnt wax stone brick"},
							ko:{name:'영구층',content:"왁스 타일"},
							ja:{name:'恒久層',content:"ワックスがけの配置"},
							point:[[484,416],[499,387],[504,382],[504,372],[499,371],[499,367],[505,364],[513,362],[524,362],[538,363],[550,365],[556,369],[560,373],[558,380],[553,381],[553,402],[494,471],[483,479],[483,463],[478,440],[474,434],[475,429]],
					},
					{
							zh:{name:'上部槽',content:"不烧镁尖晶石砖"},
							en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
							ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
							ja:{name:'保温層',content:"高強度軽量保温板の配置"},
							point:[[309,601],[319,597],[328,595],[357,589],[374,585],[414,585],[447,587],[463,588],[478,592],[487,595],[499,599],[501,599],[503,533],[489,531],[469,530],[440,529],[416,529],[389,529],[368,529],[353,530],[338,532],[316,537],[308,540]],
					},
					{
							zh:{name:'中部槽',content:"不烧镁尖晶石砖"},
							en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
							ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
							ja:{name:'保温層',content:"高強度軽量保温板の配置"},
							point:[[309,601],[319,597],[328,595],[357,589],[374,585],[414,585],[447,587],[463,588],[478,592],[487,595],[499,599],[501,599],[500,660],[496,669],[485,681],[478,684],[460,677],[461,651],[458,646],[450,640],[441,636],[433,633],[414,631],[399,630],[391,631],[377,633],[371,635],[372,689],[359,699],[349,696],[337,690],[329,683],[320,676],[314,667],[311,660],[310,653]],
					},
					{
							zh:{name:'下部槽',content:"不烧镁尖晶石砖"},
							en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
							ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
							ja:{name:'保温層',content:"高強度軽量保温板の配置"},
							point:[[290,888.],[297,883.],[310,879.],[329,876.],[354,873.],[372,872.],[395,873.],[419,875.],[441,878.],[461,883.],[477,891.],[493,901.],[495,910.],[495,918.],[501,924.],[505,933.],[506,945.],[502,950.],[497,961.],[495,961.],[496,1043],[491,1054],[482,1069],[469,1072],[449,1059],[439,1057],[313,1020],[303,1023],[302,1031],[293,1025],[292,1017],[289,919.],[287,916.],[283,915.],[283,909.],[287,906.],[290,901.]],
					},
					{
							zh:{name:'环流管',content:"不烧镁尖晶石砖"},
							en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
							ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
							ja:{name:'保温層',content:"高強度軽量保温板の配置"},
							point:[[311,1019],[307,1028],[303,1031],[305,1077],[456,1125],[465,1111],[466,1079],[455,1077],[455,1067],[451,1057],[438,1057],[401,1033],[358,1019],[323,1023]],
					},
					{
							zh:{name:'浸渍管',content:"不烧镁尖晶石砖，刚玉尖晶石质预制块"},
							en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
							ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
							ja:{name:'保温層',content:"高強度軽量保温板の配置"},
							point:[[303,1077],[460,1124],[459,1187],[305,1137]],
					},
					{
							zh:{name:'钢包',content:"暂无说明"},
							en:{name:'Insulation layer',content:"Equipped with high-strength light insulation board"},
							ko:{name:'보온층',content:"고강도 경질 보온판 설정"},
							ja:{name:'保温層',content:"高強度軽量保温板の配置"},
							point:[[466,1100],[465,1079],[470,1077],[476,1072],[486,1063],[496,1067],[506,1073],[515,1081],[521,1092],[523,1102],[523,1112],[516,1452],[515,1465],[509,1478],[500,1490],[490,1498],[282,1412],[270,1066],[277,1061],[284,1059],[294,1056],[306,1053],[305,1101],[281,1113],[305,1125],[304,1138],[322,1143],[328,1142],[334,1140],[342,1140],[349,1140],[355,1144],[359,1148],[359,1155],[401,1169],[407,1167],[414,1166],[422,1165],[428,1166],[438,1170],[440,1182],[458,1188],[465,1183],[469,1177],[482,1182],[483,1133],[491,1130],[499,1123],[501,1120],[496,1113],[483,1106],[474,1102],[470,1101]],
					}
		],
		huaDongXiTongArr:[
					{
							zh:{name:'水口座砖',content:"铝碳质或刚玉尖晶石质、铬刚玉尖晶石质、镁碳质、铝锆质预制块"},
							en:{name:'Bao Kou',content:"ASC castable with excellent thermal shock resistance and erosion resistance"},
							ko:{name:'꾸러미',content:"내열 지진 성능과 브러시 기능이 우수한 AST 소재를 설정합니다."},
							ja:{name:'包装口',content:"耐热振动性能と耐冲撃性に优れたASC素材の注入剤を配置します"},
						point:[[333,376],[324,377],[316,376],[308,375],[299,371],[298,354],[289,351],[281,349],[280,344],[266,128],[268,123],[295,121],[339,123],[341,130],[445,130],[447,124],[488,122],[516,124],[521,126],[508,346],[504,351],[490,353],[490,371],[480,374],[468,377],[436,374],[433,230],[353,229],[353,374]]
					},
					{
							zh:{name:'上水口',content:"刚玉尖晶石质、铝碳质、铝锆碳质"},
							en:{name:'Tie line area',content:"ASC brick with good slag resistance and oxidation resistance"},
							ko:{name:'단선 구역',content:"부스러기 저항성 좋은 항산화 성능 우수한 AST 벽돌"},
							ja:{name:'結束区域',content:"スラグ耐性の高い抗酸化性能に優れたASCレンガを配置します"},
							point:[[355,231],[434,231],[435,384],[435,402],[442,411],[442,442],[404,435],[404,430],[385,431],[381,435],[347,441],[347,413],[352,399]]
					},
					{
							zh:{name:'滑板',content:"铝锆碳质（含镶嵌锆板组合）、铝碳质（含镶嵌锆板组合）、镁碳质"},
							en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
							ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
							ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
							point:[[214,495],[266,485],[267,512],[269,517],[277,520],[287,525],[299,527],[325,522],[325,517],[331,517],[336,521],[345,518],[345,503],[382,495],[386,490],[393,489],[401,490],[407,493],[434,501],[443,501],[443,518],[451,520],[462,517],[487,527],[493,526],[504,522],[515,518],[521,511],[521,485],[572,493],[587,491],[601,487],[610,481],[619,475],[623,469],[623,429],[617,423],[607,418],[591,413],[573,409],[545,405],[523,403],[501,400],[491,399],[455,397],[461,405],[461,419],[470,423],[474,426],[475,433],[473,437],[467,436],[467,443],[453,441],[453,434],[444,433],[443,442],[407,435],[404,431],[393,431],[381,431],[381,437],[344,441],[343,434],[337,435],[336,442],[331,441],[324,437],[315,434],[313,427],[314,423],[321,420],[328,419],[328,406],[333,398],[305,399],[285,401],[263,404],[245,405],[227,408],[211,411],[197,413],[183,417],[173,422],[166,428],[164,435],[165,472],[169,479],[178,485],[188,489],[202,493]],
					},
					{
							zh:{name:'下水口',content:"刚玉尖晶石质、铝碳质、铝锆碳质"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[355,501],[383,494],[383,491],[394,489],[403,489],[406,493],[433,501],[434,530],[427,544],[426,567],[426,591],[423,617],[420,635],[416,652],[413,666],[407,665],[407,658],[401,656],[392,655],[386,657],[383,659],[383,664],[377,666],[373,654],[367,627],[363,596],[362,560],[363,543],[355,533]],
					},
					
		],
		dianLuGangBaoArr:[
					{
							zh:{name:'渣线',content:"镁碳砖"},
							en:{name:'Bao Kou',content:"ASC castable with excellent thermal shock resistance and erosion resistance"},
							ko:{name:'꾸러미',content:"내열 지진 성능과 브러시 기능이 우수한 AST 소재를 설정합니다."},
							ja:{name:'包装口',content:"耐热振动性能と耐冲撃性に优れたASC素材の注入剤を配置します"},
						point:[[201,455],[231,445],[225,388],[232,378],[247,364],[269,351],[300,339],[334,332],[369,327],[415,326],[458,331],[491,337],[520,347],[545,360],[564,373],[576,389],[582,416],[584,419],[613,424],[641,227],[620,225],[618,212],[610,198],[597,188],[574,174],[538,161],[490,151],[436,146],[378,146],[335,148],[302,153],[270,159],[234,170],[204,184],[190,195],[180,212],[182,224],[202,248],[171,254]]
					},
					{
							zh:{name:'包壁',content:"镁铝碳砖"},
							en:{name:'Tie line area',content:"ASC brick with good slag resistance and oxidation resistance"},
							ko:{name:'단선 구역',content:"부스러기 저항성 좋은 항산화 성능 우수한 AST 벽돌"},
							ja:{name:'結束区域',content:"スラグ耐性の高い抗酸化性能に優れたASCレンガを配置します"},
							point:[[200,457],[224,450],[231,447],[223,392],[232,377],[251,363],[277,350],[314,338],[346,333],[388,329],[425,329],[459,334],[493,343],[523,353],[546,366],[561,374],[574,387],[582,406],[581,420],[613,423],[574,666],[554,663],[554,642],[551,622],[538,605],[524,590],[505,578],[481,566],[458,559],[432,554],[407,552],[386,552],[358,554],[335,560],[310,570],[286,582],[267,599],[255,615],[249,628],[257,692],[238,703]]
					},
					{
							zh:{name:'永久层',content:"高铝质浇注料"},
							en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
							ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
							ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
							point:[[227,722],[153,246],[169,242],[239,725],[293,705],[297,715],[342,698],[342,688],[400,667],[478,677],[479,687],[529,695],[530,685],[571,692],[645,216],[662,218],[585,684],[578,694],[567,700],[530,696],[479,688],[400,677],[343,699],[295,716],[250,732],[238,733],[231,729]],
					},
					{
							zh:{name:'保温层',content:"轻质镁硅绝热板"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[226,723],[224,717],[219,715],[145,247],[152,247],[225,715],[227,724],[228,726],[230,728],[237,732],[242,734],[249,734],[257,731],[399,676],[564,700],[578,694],[585,688],[586,685],[588,674],[662,218],[668,219],[593,675],[588,682],[586,687],[579,693],[566,700],[400,676],[398,676],[256,731],[248,734],[241,734],[236,732],[231,729],[225,722],[224,720]],
					},
					{
							zh:{name:'包底',content:"铝镁碳砖"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[262,719],[258,695],[248,623],[257,610],[264,602],[274,592],[289,580],[305,572],[327,563],[346,557],[369,553],[392,552],[412,553],[440,555],[461,560],[481,566],[501,576],[516,584],[528,596],[539,607],[547,618],[554,629],[556,640],[553,664],[550,686],[533,684],[535,660],[533,650],[529,645],[519,638],[507,635],[495,635],[484,641],[477,650],[401,641],[346,661],[342,657],[334,653],[323,648],[311,650],[299,654],[291,659],[289,669],[292,680],[294,705]],
					},
					{
							zh:{name:'透气砖',content:"铬刚玉尖晶石质"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[310,709],[311,671],[310,668],[313,666],[317,665],[321,664],[324,666],[329,702],[399,675],[493,688],[496,653],[498,650],[501,648],[505,648],[508,648],[510,650],[513,652],[515,692],[399,676],[328,703]],
					},
					{
							zh:{name:'透气座砖',content:"刚玉尖晶石质"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[302,712],[299,675],[298,669],[300,663],[307,658],[314,656],[319,656],[326,658],[333,660],[335,663],[336,700],[399,677],[484,688],[485,651],[488,646],[494,642],[500,642],[506,642],[512,643],[517,645],[522,648],[525,653],[522,694],[515,692],[514,654],[511,651],[507,649],[501,649],[496,653],[493,690],[400,678],[331,702],[324,667],[322,665],[318,665],[314,665],[312,667],[310,671],[309,711]],
					},
					
		],
		zhongJianBaoArr:[
					{
							zh:{name:'永久层',content:"高铝浇注料，高铝预制块、铝锆质预制块"},
							en:{name:'Bao Kou',content:"ASC castable with excellent thermal shock resistance and erosion resistance"},
							ko:{name:'꾸러미',content:"내열 지진 성능과 브러시 기능이 우수한 AST 소재를 설정합니다."},
							ja:{name:'包装口',content:"耐热振动性能と耐冲撃性に优れたASC素材の注入剤を配置します"},
						point:[[153,486],[131,491],[88.,362],[69.,336],[633,251],[728,280],[567,310],[547,405],[517,390],[215,456],[211,472],[191,477],[192,484],[217,477],[219,461],[514,395],[551,413],[571,311],[737,280],[633,249],[60.,334],[80.,365],[127,499],[154,492]]
					},
					{
							zh:{name:'工作层',content:"镁质涂抹料、镁质喷涂料"},
							en:{name:'Tie line area',content:"ASC brick with good slag resistance and oxidation resistance"},
							ko:{name:'단선 구역',content:"부스러기 저항성 좋은 항산화 성능 우수한 AST 벽돌"},
							ja:{name:'結束区域',content:"スラグ耐性の高い抗酸化性能に優れたASCレンガを配置します"},
							point:[[153,481],[154,485],[132,490],[87.,361],[71.,337],[631,252],[727,280],[566,310],[547,403],[517,389],[515,389],[214,455],[211,471],[191,477],[191,473],[208,468],[212,452],[516,384],[545,400],[563,307],[723,279],[631,255],[76.,338],[92.,360],[135,485]]
					},
					{
							zh:{name:'挡渣堰',content:"镁质预制块"},
							en:{name:'Iron wire area',content:"ASC brick with excellent oxidation resistance and peeling resistance"},
							ko:{name:'철선 구역',content:"항산화, 착락성 저항 우수한 AST 벽돌"},
							ja:{name:'鉄線区域',content:"抗酸化、抗剥が性能に優れたASCレンガを配置します"},
							point:[[228,323],[235,320],[259,339],[264,425],[256,427],[237,409]],
					},
					{
							zh:{name:'挡渣堰',content:"镁质预制块"},
							en:{name:'Non impact area',content:"ASC brick with high strength and excellent overall performance"},
							ko:{name:'비충격 구역',content:"강도가 높고 전체 성능이 우수한 AST 벽돌 설정"},
							ja:{name:'非衝撃ゾーン',content:"配置強度が高く、全体性能が優れたASCレンガです"},
							point:[[537,274],[543,273],[613,297],[608,300],[563,307],[555,353],[541,347]]
					},
					{
							zh:{name:'湍流器',content:"镁质预制块、铝镁质预制块"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[389,387],[389,401],[401,409],[458,398],[459,383],[445,374]]
					},
					{
							zh:{name:'气幕挡墙',content:"刚玉莫来石质预制块、镁质预制块"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[353,399],[370,417],[379,415],[362,397]]
					},
					{
							zh:{name:'挡渣坝',content:"镁质预制块"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[205,402],[212,400],[227,414],[229,449],[219,450],[206,433]]
					},
					{
							zh:{name:'浸入式水口',content:"铝锆碳质"},
							en:{name:'Impact zone',content:"ASC brick with high strength and impact resistance"},
							ko:{name:'충격',content:"높은 강도, 충격에 견디는 AST 벽돌 설정"},
							ja:{name:'衝撃ゾーン',content:"高強度、耐衝撃性のASCレンガを配置します"},
							point:[[155,495],[155,481],[157,479],[159,476],[159,473],[164,471],[169,468],[175,468],[182,470],[186,473],[192,474],[193,488],[183,491],[185,500],[189,503],[164,511],[161,509],[163,504],[163,493]]
					},
					
		],
	  selectedContent:{},		
	  collectionArr:[],
	  isShowContent:false,
	  infoIndex:null,
	  currentPointsArr:[],
	  detailContent:{},
	  allDetailData:[],
	  
	  canvasEle:'',
	  bannerImage:'',
	  imageConfig: {},
	  detailCompanyInfo:'',
	  indexConfig:{},
	  nhCategoryBgUrl:'',
	  leftBlockColor:'#fff',
	  rightBlockColor:'#fff',
	  icoBigImage:'',
	  showIcoImage:false,
	  company:{},
	  zhuanLiList:[]
    }
  },
  mounted(){
	  this.getLanguage()
	  //this.selectedContent=	this.moltenIronLadleArr;
	  console.log(this.$route.query)
	  //this.getDrawPolygon(this.selectedContent)
	  this.fetch()
	  this.getCompanyDetail()
	  this.getCompanyIcoImage()
  },
  methods: {
	  
	  getLanguage () {
		  this.currentLanguage=this.lang
		  this.fetch()&&this.getImage()
		  this.fechTreeData()
		 // console.log(this.currentLanguage)
	  },
	  async getProductDetail(item){
		const res=await this.$http.post(`/getNewproduct`,{id:item.id,la:this.currentLanguage})
		this.isShowProduct = true
		this.detailContent = res.data[0]||{detail:'暂无',productName:'请配置'}
		console.log(this.detailContent)
	  },
	  handleNodeClick(data) {
        console.log(data);
		if(data.children.length===0){
			this.getProductDetail(data)
		}
      },
	  async getCompanyDetail(){
		const res=await this.$http.get(`/company/${this.$route.query.id}`)
		this.company = res.data
		this.bannerImage =  res.data.companyBannerList[0].url
		this.bgColor = res.data.companyBdColor
		this.leftBlockColor = res.data.companyBlock1Color
		this.rightBlockColor = res.data.companyDetailColor
	  },
	  async fechTreeData(){
		const res=await this.$http.get(`/category/${this.$route.query.id}`)
		const treeObj = res.data.find(v=>{
			if(v.language===this.lang){
				return v
			}
		})
		this.categoryList = treeObj?treeObj.tree:[]
	  },
	  async getImage(){
		const res=await this.$http.get('imageConfig')
		this.imageConfig = res.data[0]||{}
		// this.bannerImage = this.imageConfig.firstTabBanner
	  },
	  async getCompanyIcoImage(){//专利图标及大图
		const res=await this.$http.post(`/companyPatent`,{id:this.$route.query.id,la:this.currentLanguage})
		this.zhuanLiList=res.data[0]&&res.data[0].contentList || []
		console.log(res.data)
		console.log(this.zhuanLiList)
	  },
	  async getCompanyInfo(){
		//   const res  =  await this.$http.post('companyInfoList',{la:this.lang,type:0})
		  const res  =  await this.$http.get(`/companyInfo/${this.$route.query.id}`)
		  this.detailCompanyInfo = res.data.find(v=>v.language===this.lang)
	  },
	  getBookDetail(item){
		  console.log(item)
		  this.icoBigImage = item.detailImageList[0].url
		  this.detailContent.productName = item.icoName
		  this.detailContent.detail = "<img src='"+item.detailImageList[0].url+"' style='width:96%'>"
		  this.isShowProduct=true;
		
	  },
	  getDetailContent(){
		  this.detailContent={};
		  this.allDetailData.forEach((detail)=>{

			  if(detail.icoKey==this.currentSelectedSecondCategory&&this.currentLanguage===detail.language&&this.currentSelectedSecondName===detail.productName){
				  this.detailContent=detail;
			  }
			  if(!detail.icoKey&&this.currentSelectedSecondName==detail.productName){   
				  this.detailContent=detail;//如果 没有模型  需要标题相同
			  }
		  })
	  },
	  getImageContent(key){
		  var map = {
            1:require('../assets/images/model/1-1.jpg'),
			2:require('../assets/images/model/1-2.jpg'),
			3:require('../assets/images/model/null-bd.png'),
			4:'four',
			5:'five',
			6:require('../assets/images/model/2-4.jpg'),
			7:require('../assets/images/model/2-5.jpg'),
			8:require('../assets/images/model/2-6.jpg'),
			9:require('../assets/images/model/3-1.jpg'),
			10:require('../assets/images/model/3-2.jpg'),
			11:require('../assets/images/model/3-3.jpg'),
			12:require('../assets/images/model/3-4.jpg'),
			13:'Thirteen'
	    };
	    return map[key];
	  },
	  getStyle(item){
		  return 'width:'+item.icoSize+'px'
	  },
	  getProductByCategory(secondCategory){
		     if(secondCategory.key==null){
				console.log(secondCategory)
				this.currentSelectedSecondCategory=secondCategory.key;
				this.currentSelectedSecondName=secondCategory.label;
				this.isShowProduct=true;
			    this.isShowCanvas=false;
				 this.fetch()
				 return
			 }
		  	 this.currentSelectedSecondCategory=secondCategory.key;
		  	 this.currentSelectedSecondName=secondCategory.label;
			 this.isShowProduct=true;
			 this.isShowCanvas=true;
			// this.drowImage(this.getImageContent(secondCategory.key))
			
		     if(secondCategory.key==1){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=	this.moltenIronLadleArr;
				// this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			 }else if(secondCategory.key==2){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=	this.yuLeiGuanArr;
				 //this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			 }else if(secondCategory.key==3){
				 this.isShowCanvas=false;
				 this.collectionArr=[];
				 this.fetch()
			 }
			 
			 else if(secondCategory.key==6){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=this.zhuanLuArr;
				 //this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			 }
			 else if(secondCategory.key==7){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=this.RHLuArr;
				// this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			 }
			 else if(secondCategory.key==9){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=this.zhuanLuGangBaoArr;
				// this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			 }
			 else if(secondCategory.key==10){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=this.dianLuGangBaoArr;
				// this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			 }
			 else if(secondCategory.key==11){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=this.huaDongXiTongArr;
				 //this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			 }
			 else if(secondCategory.key==12){
				 this.isShowCanvas=true;
				 this.collectionArr=[];
				 this.selectedContent=this.zhongJianBaoArr;
				 //this.getDrawPolygon(this.selectedContent)
				 this.fetch()
			  }else if(secondCategory.key==13){
				this.isShowCanvas=false;
				this.collectionArr=[];
				this.fetch()
			   }else{
				  this.isShowCanvas=true;
				  this.collectionArr=[];
				  this.selectedContent=[];
				  //this.getDrawPolygon(this.selectedContent)
				  this.fetch()
			  }
							  
	  },
	  getCanvasLanguageContent(num){
		  if(this.currentLanguage=="zh"){
			  return num.zh.content
		  }else if(this.currentLanguage=="en"){
			  return num.en.content
		  }else if(this.currentLanguage=="ko"){
			  return num.ko.content
		  }else if(this.currentLanguage=="ja"){
			  return num.ja.content
		  }
		  
	  },
	  getCanvasLanguageTitle(num){
		  if(this.currentLanguage=="zh"){
		  			  return num.zh.name
		  }else if(this.currentLanguage=="en"){
		  			  return num.en.name
		  }else if(this.currentLanguage=="ko"){
		  			  return num.ko.name
		  }else if(this.currentLanguage=="ja"){
		  			  return num.ja.name
		  }
	  },
	  async fetch(){
	  	
		this.getDetailContent();
		this.getCompanyInfo()
		this.fetchIndex()
	  	//console.log(res.data)					  
	  },
	  async fetchIndex(){
		const res=await this.$http.post('/indexConfig',{la:this.currentLanguage})
		this.indexConfig = res.data || {}
		if(this.indexConfig.nhCategoryBgUrl&&this.indexConfig.nhCategoryBgUrl[0]){
			this.nhCategoryBgUrl = this.indexConfig.nhCategoryBgUrl[0]['url']
		}else{
			this.nhCategoryBgUrl = ''
		}
	  },
	  getDrawPolygon:function(polygon){
	  		    polygon.forEach(function(data) {
	  				//console.log(data)
	  				this.collectionArr.push(data.point);		  	
	  			}.bind(this))
	  		    this.drawPolygons();
	  },	
	  drawPolygons: function(data){
	    var canvas = document.getElementById('areaCanvas');
	  	//console.log(canvas)
	    if (null == canvas || !canvas.getContext) return;
	    var ctx = canvas.getContext("2d");
	    // 清除画布，准备绘制
	    // ctx.clearRect(0, 0, canvas.width, canvas.height);
	    this.drawPolygonByPoint(ctx,null);
	    var _this = this;
	    canvas.onmousemove = function (e) {
	      ctx.clearRect(0, 0, canvas.width, canvas.height);
	      var location = _this.getLocation(canvas, e.clientX, e.clientY);
	      _this.drawPolygonByPoint(ctx, location);
	    };
	  		// canvas.onmouseout=function(){
	  		// 	_this.infoIndex=null;
	  		// }
	  },
	  drawPolygonByPoint: function(ctx,location){
		  //一个点同时在两个区域时用areaNum判断
		  var areaNum=0;
	    this.collectionArr.map((pointsArr,index) =>{
			//console.log(location)
	      if(location != null && inside(location, pointsArr,index) == true){
			  areaNum++
	        //绘制高亮图形
	  			
				this.currentPointsArr=pointsArr;
				if(areaNum>1){
					if(index<this.infoIndex){
						this.drawHighLightPolygon(ctx,pointsArr,location);
						this.infoIndex=index;
					}
				}else{
					this.infoIndex=index;
					this.drawHighLightPolygon(ctx,pointsArr,location);
				}
				
	  			//this.drawGeneralPolygon(ctx,pointsArr);	
						 // console.log(areaNum)
	      }else{
	        //绘制一般图形
	        this.drawGeneralPolygon(ctx,pointsArr);
	      }
	    });
		if(location != null&&inside(location, this.currentPointsArr)==false){
			this.infoIndex=null;
		}
	  },
	  drawGeneralPolygon: function(ctx,pointsArr){
	    ctx.beginPath();
	    for(let i = 0; i < pointsArr.length; i++){
	      if(i == 0){
	        ctx.moveTo(pointsArr[i][0], pointsArr[i][1]);
	      }else if(i < pointsArr.length - 1){
	        ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
	      }else{
	        ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
	  			//ctx.lineWidth =9;
	  			//ctx.strokeStyle = "red"
	        //ctx.closePath();
	       // ctx.stroke();
		   
	      }
	    }
		
	  },
	  drawHighLightPolygon: function(ctx,pointsArr,location){
	    ctx.beginPath();
	  		document.getElementById("textContent").style.top=location[1]-180+'px';
	  		document.getElementById("textContent").style.left=location[0]-20+'px'
	    for(let i = 0; i < pointsArr.length; i++){
	      if(i == 0){
	        ctx.moveTo(pointsArr[i][0], pointsArr[i][1]);
	      }else if(i < pointsArr.length - 1){
	        ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
	      }else{
	        ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
	        ctx.fillStyle="rgba(255,72,0,0.6)";
	  			ctx.lineWidth = 1;
	  			ctx.strokeStyle = "rgba(255,108,0,0.1)"
	        ctx.fill();
	        ctx.closePath();
	        ctx.stroke();
	  	
	      }
	    }
	  },
	  getLocation: function(canvas,x,y){
	    var bbox = canvas.getBoundingClientRect();
	  		//console.log((x - bbox.left) * (canvas.width / bbox.width),(y - bbox.top) * (canvas.height / bbox.height))
	    return [(x - bbox.left) * (canvas.width / bbox.width),(y - bbox.top) * (canvas.height / bbox.height)];
	      /*
	       * 此处不用下面两行是为了防止使用CSS和JS改变了canvas的高宽之后是表面积拉大而实际
	       * 显示像素不变而造成的坐标获取不准的情况
	      x: (x - bbox.left),
	      y: (y - bbox.top)
	      */
	  },
	  drowImage(url){
		  this.canvasEle = document.getElementById("areaCanvas");
		  this.canvas2d=this.canvasEle.getContext('2d');
		  this.loadImage(url,this.imageType,this.canvasEle,this.canvas2d);
	  },
	  loadImage(url,imageType,canvasEle,canvas2d) {
	      return new Promise((resolve)=>{
	  	   const imageType = new Image();
	  	   imageType.crossOrigin = 'anonymous';
	   	   imageType.src = url;
	  	   imageType.onload = ()=>{
	  		 canvasEle.setAttribute("width", imageType.width);
	  		 canvasEle.setAttribute("height", imageType.height);
	  		 resolve(imageType.src);
	  	   };			  
	      })
	  },
	  getColorClass:function(key){
		  
	    var map = {
            1:"one",
			2:'two',
			3:'three',
			4:'four',
			5:'five',
			6:'six',
			7:'seven',
			8:'eight',
			9:'nine',
			10:'tan',
			11:'eleven',
			12:'Twelve',
			13:'Thirteen'
	    };
	    return map[key];	  
	  }, 
	  goCurrentHome(){
		  this.isShowProduct = false
	  }
  },
  watch: {
  		// 如果路由有变化，会再次执行该方法
  		"$route": "getLanguage"
  }
  
}
</script>
<style lang="scss" scoped>
.el-tree{
	background: none!important
}

/deep/.el-tree .el-tree-node__content{
	white-space: normal;//超出换行
	height: 100%;
			align-items: start;
			font-weight: 600;
			color:#333;
}
/deep/.el-tree .el-tree-node__content:hover{
	background: none;
}
/deep/.el-tree .el-tree-node:focus{
	background: none;
}
/deep/.el-tree-node__label{
	font-size: 17px;
}
</style>
<style>

	.commom-product-c{
		 display: flex;
		 flex-direction: row;
		 justify-content: space-between;
	}
	.product-c .f-l{
		background: #fff;
		-moz-box-shadow:0px 0px 0px #999999, 1px 2px 4px #999999; 
		-webkit-box-shadow:0px 0px 0px #999999, 1px 2px 4px #999999;
		box-shadow:0px 0px 0px #999999, 1px 2px 4px #999999;
	     margin: 15px 0;
	 }
	.product-c .l-content{
		width: 220px;
		margin: 15px;
		position: relative;
		height: 100%;
	}
	.product-c .l-content .bg-img{
		position: absolute;
		bottom: 0;
		width: 100%;
	}
	.banner-c img{
		width: 100%;
	}
	.product-c .l-content ul li{
		width: 220px;
		height: 52px;
		/* border-bottom: 1px solid#f7f8f9; */
		padding-left: 23px;
		font-size: 18px;
		color: #212121;
		font-weight: 600;
		line-height: 52px;
		cursor: pointer;
		position: relative;
		z-index: 1;
	}
	.product-c .l-content ul li.on{
		background: rgba(255,255,255,0.25);
		border-bottom: 0px;
	}
	.product-c .l-content ul li.on span.arrow-ico{
		width: 30px;
		height: 52px;
		position: absolute;
		right: -30px;
		top:0px;
		display: block;
		/* background: url(../assets/images/product_ico.jpg) -76px 8px no-repeat; */
		z-index: 0;
	}
    .product-c .head-c{
		padding: 0 17px;
	}
	.product-c .l-content .second-category{
		position: absolute;
		right: -297px;
		top: 0;
		width: 277px;
		padding: 8px;
		background: #fff;
		box-shadow:1px 2px 4px rgba(0,0,0,.2);
		z-index: -1;
		font-size: 16px;
		font-weight: 100;
		
	}
	.product-c .l-content .second-category .second-c.title{
		font-size: 18px;
		padding-left: 0px;
	}
	.product-c .l-content .second-category .second-c.title.on{
		color: #333;
		cursor: pointer;
	}
	.product-c .l-content .second-category .second-c{
		padding-left: 29px;
	}
	.product-c .l-content .second-category .third-c{
		font-size: 16px;
		margin-left: 10px;
	}
	.product-c .l-content .second-category .second-c.title span.second-ico{
		background: url(../assets/images/product_ico.jpg) -0px 0px no-repeat;
		width: 30px;
		height: 30px;
		display: block;
		float: left;
		cursor: pointer;
	}
	.product-c .l-content .second-category .second-c.title.on span.second-ico{
		background: url(../assets/images/product_ico.jpg) -0px 0px no-repeat;
	}
	.product-c .l-content .second-category .second-c.on span.second-ico{
		background: url(../assets/images/product_ico.jpg) -35px 1px no-repeat;

	}
	.product-c .l-content .second-category .second-c.on{
		color: #ff6600;
	}
	.product-c  .product-right-c{
		background: #fff;
		box-shadow:1px 2px 4px rgba(0,0,0,.2);
		width: 920px;
		padding: 20px;
		min-height: 665px;
		margin-top: 15px;
		margin-bottom: 15px;
	}
	.product-right-c .product-head-c .title{
		font-size: 17px;
		font-weight: 600;
		color: #333;
		margin: 4px 0 8px 0;
	}
	.product-right-c img{
		max-width: 100%;
	}
	.product-c .product-head-c{flex:1}
	.product-c .product-head-c .line-c{
		border-bottom: 1px solid#f2f2f2;
		width: 870px;
		
	}
	.product-c .product-head-c .line-c span{
		display: block;
		width: 88px;
		background: #2f44dd;
		height: 5px;
	}
	.product-canvas.one{width:100%;height:100%;background: url(../assets/images/model/1-1.jpg) 0 0 no-repeat}
	.product-canvas.two{width:100%;height:100%;background: url(../assets/images/model/1-2.jpg) no-repeat}
	.product-canvas.three{width:100%;height:100%;background: url(../assets/images/model/null-bd.png) no-repeat}
	.product-canvas.four{width:100%;height:100%;background: url(../assets/images/model/2-2.jpg) no-repeat}
	.product-canvas.five{width:100%;height:100%;background: url(../assets/images/model/2-3.jpg) no-repeat}
	.product-canvas.six{width:100%;height:100%;background: url(../assets/images/model/2-4.jpg) no-repeat}
	.product-canvas.seven{width:100%;height:100%;background: url(../assets/images/model/2-5.jpg) no-repeat}
	.product-canvas.eight{width:100%;height:100%;background: url(../assets/images/model/2-6.jpg) no-repeat}
	.product-canvas.nine{width:100%;height:100%;background: url(../assets/images/model/3-1.jpg) no-repeat}
	.product-canvas.tan{width:100%;height:100%;background: url(../assets/images/model/3-2.jpg) no-repeat}
	.product-canvas.eleven{width:100%;height:100%;background: url(../assets/images/model/3-3.jpg) no-repeat}
	.product-canvas.Twelve{width:100%;height:100%;background: url(../assets/images/model/3-4.jpg) no-repeat;}
	.product-canvas.Thirteen{width:100%;height:100%;background: url(../assets/images/model/3-5.jpg) no-repeat;}
	.product-canvas .tip-content{position: absolute;}
	.product-canvas .tip-content .tip{		
		width: 330px;
		padding: 20px;
		background: #000;
		border-radius: 10px;
		
		border:1px solid#ccc;
		color: #fff;
	}
	.product-canvas .tip-content .tip .title{
		font-size: 18px;
		color: #F0AD4E;
		line-height: 30px;
	}
	.book-c .book-title{
		text-align: center;
	}
	.book-c-wrapper{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-end;
	}
	.book-c-wrapper img{
		cursor: pointer;
	}
</style>